export default __webpack_public_path__ + "static/media/image 19.cd35ec33.png";